<template>
	<div id="main">
		<v-header v-on:islogin='islogin'></v-header>

		<!-- 视频播放 -->
		<div class="videoBox" id="videoBox">
			<div class="index-title">
				<div class="video" id="displayDiv">
				</div>
				<div></div>
				<div class="videoList" id="videoList" :style="{right:videoListLeft+'px'}">
					<div class="triangle-left" v-show="videoListLeft== -240"  @click="videoListLeft = 0"></div>
					<!--课程目录-->
					<h1>课程目录
						<div class="triangle-right" v-show="videoListLeft== 0"  @click="videoListLeft = -240"></div>
					</h1>
					<div class="list directorylist_box">

						<div class="directory">
							<div class="directory_list" :class="{'highColor': listIndex == index}" v-for="(item, index) in PlaybackList"  v-bind:key="item.id" @click="getCCVideo(item.CCId,index)">{{item.Title}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
		<v-login v-on:guanbi='guanbi' v-show="login"></v-login>
	</div>
</template>

<script>
	import vHeader from '@/components/common/header'
	import vFooter from '@/components/common/footer'
	import vLogin from '@/components/common/login'

	export default {
		data() {
			return {
				courseInfo: [],
				PlaybackList: [],
				allCoursewareList:[],
				CCVideoId: "",
				videoListLeft:0,
				current: 1,
				listIndex: 0,
				login: 0,
				directory: [1, 2, 3, 4, 5, 6, 7, 8, 9, 1, 0, 98, 76, 5, 4, 3, 2, , 34, 56, 7, 8, 7]
			};
		},
		created() {
			this.getCourseDetails()
		},
		methods: {
			islogin: function(islogin) {
				this.login = islogin
			},
			guanbi: function(guanbi) {
				this.login = guanbi
			},
			getCourseDetails() {
				var _this = this
				this.axios.get("/api/CompetitionVideo/GetVideo")
					.then(response => {
						response.data = JSON.parse(response.data)
						console.log(response)
						if (response.data.ErrorCode === 1) {
							_this.courseInfo = response.data.Data
							_this.PlaybackList = response.data.Data.PlaybackList
							_this.CCVideoId = response.data.Data.PlaybackList[0].CCId
							_this.getCCVideo(_this.CCVideoId, 0)
							for (var i = 0; i < response.data.Data.PlaybackList.length; i++) {
								for (var j = 0; j < response.data.Data.PlaybackList[i].CoursewareList.length; j++) {
									_this.allCoursewareList.push(response.data.Data.PlaybackList[i].CoursewareList[j])
								}
							}
							for (var j = 0; j < response.data.Data.PlaybackList.length; j++) {
								if (response.data.Data.PlaybackList[j].PageTitle !== "") {
									_this.isPageTitle3 = 1
									break;
								}
							}
							setTimeout(function (){
								_this.videoListLeft = -240
							}, 3000);
						} else {
							console.log(response.data.ErrorCode)
						}
					})
					.catch(error => {
						console.log(error)
					})
			},

			getCCVideo (CCVideoId, index) {
			  // 切换章节传入PlaybackId，根据PlaybackId获取章节评论
			  // this.PlaybackId = PlaybackId
			  this.loading = true
			  this.screenWidth = 0
			  var _this = this
			  setTimeout(function () {
			    _this.loading = false
			  }, 1000)
			  document.getElementById('displayDiv').innerHTML = ''
			  this.listIndex = index
			  // 视频全屏
			  var videoWidth = 0.793 * window.document.body.offsetWidth
			  var videoHeight = 0.91 * window.screen.availHeight
			  document.getElementById('videoList').style.height =  '100%'
			  document.getElementById('videoBox').style.height = '100%'
			  this.screenWidth = window.document.body.offsetWidth
			  var _script = document.createElement('script')
			  _script.setAttribute('type', 'text/javascript')
			  _script.setAttribute('src', 'https://p.bokecc.com/player?vid=' + CCVideoId + '&siteid=2C0F1209F9B02A2C&autoStart=true&width=100%&height=100%&playerid=991A71F8E4303AAB&playertype=1')
			  // 判断是否加载
			  console.log(_script)
			  document.getElementById('displayDiv').appendChild(_script)
			  var head = document.getElementsByTagName('head')[0]
			  var script = document.createElement('script')
			  script.type = 'text/javascript'
			  script.src = 'https://p.bokecc.com/player?vid=' + CCVideoId + '&siteid=2C0F1209F9B02A2C&autoStart=false&width=100%&height=100%&playerid=991A71F8E4303AAB&playertype=1'
			  head.appendChild(script)
			  script.onload = script.onreadystatechange = function () {
			    if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
			      this.loading = false
			      script.onload = script.onreadystatechange = null
			    }
			  }
			}

		},
		components: {
			vHeader,
			vFooter,
			vLogin,
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.videoBox {
		position: relative;
		background: url("../../assets/4.jpg") no-repeat center center;
		background-size: cover;
		min-height: calc(100vh - 120px);
		text-align: center;

		.index-title {
			width: 900px;
			height: 85%;
			// padding-right: 20px;
			border: 2px solid #fff;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			margin: auto;
			display: flex;
			overflow: hidden;
			.video {
				flex: 1;
				background: #000;
				height: 100%;
			}
			.videoList {
				width: 240px;
				position: absolute;
				top: 0;
				transition: 0.5s;
				height: 100%;
				right: -210px;
        z-index:9999999;
				.triangle-left{
					width:0;
					height:0;
					border-top:10px solid transparent;
					border-bottom:10px solid transparent;
					border-right:20px solid white;
					position: absolute;
					left: -20px;top: 30px;
					z-index: 9999999;
				}
				h1 {
					position: absolute;
					color: #fff;
					background: #3e1976;
					height: 40px;
					line-height: 40px;
					width: 242px;
					top: -2px;
					.triangle-right{
						width:0;
						height:0;
						border-top:10px solid transparent;
						border-bottom:10px solid transparent;
						border-left:20px solid white;
						position: absolute;
						top: 10px;left: 0;
					}
				}

				.directorylist_box {
					height: 100%;
					overflow: scroll;
					padding-top: 40px;
					padding-bottom: 15px;
					background: #fff;
					.directory {
						padding: 0 4px 0 6px;
						.directory_list {
							padding: 10px 5px;
							background: #ededed;
							margin-top: 10px;
							text-align: left;
							white-space: nowrap;
				           overflow: hidden;
				           text-overflow: ellipsis;
						   font-size: 14px;
						}
						.highColor{
							background: #3e1976;
							color: #fff;
						}
					}
				}

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/video/video.vue